import * as qtFill from "../qtrax_utils/fill_all";

import { ModalHandler } from "@lib/ModalHandler";
import { getSOID } from "@lib/qtrax_utils/form_util";
import { Accessor } from "solid-js";
import { API_INFO, getApiKeyFromStorage, logAutofillMessage } from "./api";

export const VALID_HOSTNAMES = ["www.qtraxweb.com"];
export function isHostnameValid(): boolean {
  const hostname = location.hostname;
  return VALID_HOSTNAMES.includes(hostname);
}

export async function startFillAgnostic(modalHandler: Accessor<ModalHandler>) {
  API_INFO.api_token = getApiKeyFromStorage();

  try {
    await qtFill.completeSurvey(modalHandler);
  } catch (error) {
    console.error("Error during autofill:", error);
    modalHandler().addErrorMsg(String(error).slice(0, 300));

    // Capture full stack trace for logging
    const errorMessage = error instanceof Error && error.stack != null ? error.stack : String(error);

    void logAutofillMessage(getSOID(), "exception", errorMessage);
  }
}
